/* eslint-disable @typescript-eslint/prefer-optional-chain */

import axios from 'axios'
import { pageEvent, trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { AutoProduct } from 'src/enums/AutoProduct'
import { autoProposalRedirectUrl } from './config'
// import { getCookie } from 'cookies-next'

const TIMEOUT_6000 = 6000

const goToProposal = (pid, product) => {
  let appendUrl = ''
  if (typeof window !== 'undefined' && window.location.search) {
    appendUrl = `${window.location.search}&proposal_id=${pid}`
  } else {
    appendUrl = `?proposal_id=${pid}`
  }
  const urlToRedirect = `${process.env.BASE_URL || ''}${autoProposalRedirectUrl[product](appendUrl)}`
  window.location.href = urlToRedirect
}

export const handleRegNumberValidation = (regNo, setErrors, product, regexPatternsData) => {
  const errors = {}
  let formIsValid = true

  if (!regNo) {
    formIsValid = false
    errors[product] = 'Enter a valid registration number'
  } else {
    const formattedRegNo = regNo.toUpperCase().replace(/[. ,:-]+/g, '')
    const isValid = regexPatternsData.some(pattern => new RegExp(pattern, 'i').test(formattedRegNo))

    if (!isValid) {
      formIsValid = false
      errors[product] = 'Enter a valid registration number'
    }
  }

  setErrors(errors)
  return formIsValid
}

const illogicalFLowConst = [
  'ILLOGICAL_FLOW_POLICY_EXISTS',
  'ILLOGICAL_FLOW_PAYMENT_DONE',
  'ILLOGICAL_FLOW_POLICY_EXPIRED_RENEWAL_DUE',
  'ILLOGICAL_FLOW_UNACCEPTABLE_ASSET',
]

export const handleSubmit = async ({
  proposalAPIUrl,
  regNo,
  userData,
  setIsFetching,
  setErrors,
  setProposalAPIResponse,
  setShowIllogicalFlowModal,
  InsuretrackEventName,
  InsureSegmentTrackProps,
  inputCtaText,
  product,
  setShowError,
  regexPatternsData
}) => {
  if (handleRegNumberValidation(regNo, setErrors, product, regexPatternsData)) {
    setIsFetching(true)
    const startTime = new Date().getTime()

    try {
      await trackEvent(InsuretrackEventName || '', {
        ...InsureSegmentTrackProps,
        registration_number: regNo,
        cta_text: inputCtaText || 'Get quote',
      })
    } catch (error) {
      console.log('[Proposal API track event]', error)
    }

    // GET Proposal
    await axios
      .request({
        method: 'post',
        url: proposalAPIUrl,
        headers: {
          'X-Landing-URL': typeof window !== 'undefined' ? window.location?.href : '/',
          'X-Landing-Path': '/',
          'x-app-name': 'frontend-seo',
        },
        data: {
          registration_number: regNo,
          mobile_no: userData?.phone || '',
          origin: product === AutoProduct.Car ? 'acko' : 'acko_bike',
          product: product === AutoProduct.Car ? 'car' : 'bike',
          is_new: false,
        },
        timeout: TIMEOUT_6000,
      })
      .then(async res => {
        const endTime = new Date().getTime()
        await pageEvent('auto_api_success', { gross_premium: endTime - startTime })
        if (res.data?.error_code) {
          setProposalAPIResponse(res?.data)
          const isIllogicalFlow = illogicalFLowConst.filter(key => key === res.data?.error_code).length > 0
          isIllogicalFlow && setShowIllogicalFlowModal(isIllogicalFlow)
        } else {
          // ekey is the proposal id
          res.data.ekey && goToProposal(res.data.ekey, product)
        }
        setIsFetching(false)
      })
      .catch(error => {
        const err = JSON.stringify(error?.request?.response).toUpperCase()
        if (err.includes('MODEL_UNSERVICEABLE')) {
          setProposalAPIResponse({
            error_code: 'MODEL_UNSERVICEABLE',
            error_context: {
              user_logged_in: false,
              last_digits: '',
              redirect_url: null,
              vehicle_type: product,
            },
          })
          setShowIllogicalFlowModal(true)
        }
        setIsFetching(false)
        if (error?.request?.status === 400) {
          const errorObject = JSON.parse(error?.request?.response)
          const errors = {}
          errors[product] = errorObject?.error_message
          setErrors(errors)
          setShowError(true)
        }
      })
      .finally(() => {
        setIsFetching(false)
      })
  }
}
